<template>
  <div
    ref="aiInto"
    class="ai_into_wrap"
    :class="[{ hidebox: scrollHideBox, showbox: !scrollHideBox }]"
    @click="goAi()"
  >
    <img class="ai_into" src="@/assets/img/activity/ai/ai.png" alt="" />
  </div>
</template>

<script>
export default {
  name: "AiFloatingAction",
  props: {
    componentConfig: {
      type: Object,
      default: () => {},
    },
    pageConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      scrollHideTimeout: null,
      scrollHideBox: false,
    };
  },
  mounted() {
    this.$sensors.track("WidgetShow", {
      $element_id: "sensor_bcop_aiassis",
      bcopExrinfo: {
        pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}||${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
      },
    });

    window.addEventListener("scroll", () => {
      this.scrollHideAiFloatbox();
    });
  },
  methods: {
    scrollHideAiFloatbox() {
      clearInterval(this.scrollHideTimeout);
      this.scrollHideBox = true;
      this.scrollHideTimeout = setInterval(() => {
        this.scrollHideBox = false;
      }, 500);
    },
    goAi() {
      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_aiassis",
        bcopExrinfo: {
          pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}||${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
        },
      });
      this.$router.push({
        path: "/Ai",
        query: {
          pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}||${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
          actid: this.$route.params.pageId,
          shareIcon: encodeURIComponent(
            `${JSON.parse(this.$store.state.commonStore.shareConfig).shareIcon}`
          ),
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.ai_into_wrap {
  display: block;
  position: fixed;
  right: 0;
  top: 365px;
  width: 90px;
  height: 90px;
  z-index: 999;

  &.hidebox {
    animation: toHide 0.5s ease-in-out 0s forwards;
  }

  &.showbox {
    right: -46px;
    animation: toShow 0.5s ease-in-out 0s forwards;
  }

  @keyframes toHide {
    0% {
      right: 0;
    }
    100% {
      right: -46px;
    }
  }

  @keyframes toShow {
    100% {
      right: 0;
    }
    0% {
      right: -46px;
    }
  }
  .ai_into {
    width: 100%;
    height: auto;
  }
}
</style>
